import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { fetchTags, getTagStatus, selectTags, createTag } from 'features/tags/tagsSlice';
import { SelectionAutocomplete } from 'components';
import { Formik, Form, Field } from 'formik';
import { editItem } from 'features/common/editItemSlice';
import { useSnackbar } from 'notistack';
import { SnackbarDismiss } from 'GeminiViewerComponent/components/SnackbarDismiss';
import { accountsSlice } from 'app/store';
import { deleteKey } from 'GeminiViewerComponent/helpers';
import { areIntegerArraysEqual } from 'GeminiViewerComponent/helpers/arrayUtils';
import { setIsEditingTag } from 'features/common/formSlice';
const { selectActiveUser } = accountsSlice;

export function ItemTagEdit({ rowData }) {
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const [itemTags, setItemTags] = useState([]);
    const [initValues, setInitValues] = useState({ ...rowData });
    const [clearConfirm, setClearConfirm] = useState(false);
    const [isModified, setIsModified] = useState(false);
    const activeUser = useSelector(selectActiveUser);
    const user = JSON.parse(localStorage.getItem('user'));
    let tagIdList = [];
    if (rowData?.tags && rowData?.tags.length > 0) {
        tagIdList = {
            tag_ids: rowData?.tags.map((a) => a.tag_id),
        };
    }
    useEffect(() => {
        const setValues = async () => {
            setInitValues({
                ...initValues,
                ...tagIdList,
            });
            if (tagIdList?.tag_ids) {
                setItemTags([...tagIdList.tag_ids]);
            }
        };
        setValues();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rowData]);

    function onCustomChange(values) {
        let tagIdsList = values.map((a) => a.tag_id).filter((t) => t != undefined);

        setInitValues({
            ...initValues,
            tag_ids: tagIdsList,
        });
        setItemTags([...tagIdsList]);

        var changed = !areIntegerArraysEqual(tagIdsList, tagIdList.tag_ids ?? []);

        setIsModified(changed); // Set to true if there's a change
        dispatch(setIsEditingTag(changed));
    }

    function cancelItemTagEdit() {
        setClearConfirm(true);
    }

    const handleItemTagEdit = async () => {
        if (activeUser.role !== 'User') {
            let resultAction = await dispatch(
                editItem({
                    zone_id: rowData?.zone_id,
                    item_id: rowData?.item_id,
                    tag_ids: itemTags,
                })
            );
            if (resultAction.error) {
                enqueueSnackbar('Tags not updated. Please try again.', {
                    action: (key) => <SnackbarDismiss key={'error'} />,
                    variant: 'error',
                });
            } else {
                enqueueSnackbar('Tags updated.', {
                    action: (key) => <SnackbarDismiss key={'success'} />,
                    variant: 'success',
                });
            }
            setClearConfirm(false);
            deleteKey(`tags_${user.user_id}`);
            dispatch(fetchTags({ sort: 'name' }));
            setIsModified(false);
            dispatch(setIsEditingTag(false));
        }
    };
    return (
        <>
            <Formik enableReinitialize={true} initialValues={{ ...initValues }}>
                {() => (
                    <Form style={{ width: '90%' }}>
                        <Field name="tag_ids">
                            {({ field: { value }, form: { setFieldValue } }) => (
                                <SelectionAutocomplete
                                    id={`input-tags-select-${rowData?.zone_id}-${rowData?.item_id}`}
                                    style={{ height: 'auto' }}
                                    placeholder="Item Tags"
                                    size="small"
                                    keyProperty="tag_id"
                                    nameProperty="name"
                                    entityIds={value}
                                    setEntityIds={(field, value) => {
                                        setFieldValue(field, value);
                                        setItemTags(value);
                                    }}
                                    entitySelector={selectTags}
                                    entityStatusSelector={getTagStatus}
                                    fetchEntityPage={fetchTags}
                                    fetchParams={{ sort: 'name' }}
                                    formField={'tag_ids'}
                                    enableCreatable
                                    creatableDialogTitle={'tag'}
                                    creatableDialogFieldLabel={'Tag'}
                                    creatableDispatch={createTag}
                                    showCloseItemEdit={activeUser.role !== 'User' && isModified}
                                    handleItemTagEdit={handleItemTagEdit}
                                    onCustomChange={onCustomChange}
                                    cancelItemTagEdit={cancelItemTagEdit}
                                    showInitialValuesAlways={activeUser.role === 'User'}
                                    fieldValidationLength={150}
                                />
                            )}
                        </Field>
                    </Form>
                )}
            </Formik>
            <Dialog
                open={clearConfirm}
                onClose={(e) => setClearConfirm(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">Cancel Changes</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">Do you want to cancel changes?</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={(e) => {
                            setClearConfirm(false);
                        }}
                    >
                        No
                    </Button>
                    <Button
                        onClick={(e) => {
                            setInitValues(
                                JSON.parse(
                                    JSON.stringify({
                                        ...tagIdList,
                                    })
                                )
                            );
                            setItemTags(tagIdList?.tag_ids);
                            setIsModified(false);
                            setClearConfirm(false);
                            dispatch(setIsEditingTag(false));
                        }}
                        autoFocus
                    >
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
